module.exports = __webpack_public_path__ + "img/inactive-location.666fcdcd.svg";